import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import TestimonialSlider from "../Elements/TestimonialSlider";

export default function Blog() {
  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">What We Offer</h1>
            <p className="font13">
            A partnership with us is guaranteed to bring you success. Here are some benefits that you can gain from our value chain.
              
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Enterprise level process applied during development"
                text="Development activities are streamlined and practiced in accordance with industry-level best practices and frameworks such as Agile methodologies, DevOps practices, ISO standards etc."
                tag=""
                author=""
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Flexible milestone-driven delivery with guaranteed target achievement."
                text="Our approach to a milestone-driven delivery process ensures successful demonstration of continuous improvement on pre-agreed project objectives successfully."
                tag=""
                author=""
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Effective communication"
                text="We believe in building long-term stronger relationships and collaborations through our communication best practices."
                tag=""
                author=""
                action={() => alert("clicked")}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Easy, installment-based payment schemes customized to your requirements."
                text="We provide convenience and flexibility to our customers in managing their cash flows effectively while catering to their customized business needs."
                tag=""
                author=""
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="Project teams composed of experts recognized by leading companies worldwide."
                text="We possess individuals who are highly regarded and acknowledged for their expertise by prominent organisations on a global scale with a commitment to excellence."
                tag=""
                author=""
                action={() => alert("clicked")}
              />
            </div>
            
          </div>
          <div className="row flexCenter">
            
          </div>
        </div>
      </div>
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold"></h1>
            <p className="font13">
              
              <br />
              
            </p>
          </HeaderInfo>
          {/* <TestimonialSlider /> */}
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;